import Vue from "vue";

export default {
  fetchRoom({ commit, state },data) {
    console.log
    Vue.axios
      .get(`${state.api}/livestream/chatroom/list/list?idlivestream=${data.liveId}`)
      .then((res) => {
        const rooms = res.data.result;
        commit('setLiveRooms', rooms);
      })
      .catch((err) => {
        this.errMsg = err.response.data.message;
      });
  }
}